import { render, staticRenderFns } from "./adminAIReviews.vue?vue&type=template&id=e8af037c&"
import script from "./adminAIReviews.vue?vue&type=script&lang=js&"
export * from "./adminAIReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports